export default __webpack_public_path__ + "77652d7dd9dd475de502fa9c6e3adc44.png";